<h5
    class="mb-2 appTooltip"
    appTooltip="{{consts.TOOLTIP_MESSAGE}}"
    tooltipPosition="right"
>
    {{consts.TITLE}}
    <mat-icon svgIcon="hub_info"></mat-icon>
</h5>
<div class="row">
    <div class="link-content-card"
        *ngFor="let department of corporateDepartments"
        appInsightsTrack
        [eventData]=department
        loc="{{consts.TITLE}}"
        (click)="openLink(department.link)"
    >
        <mat-icon
            class="function-icon"
            [svgIcon]="department.iconURL"
        >
        </mat-icon>
        <p class="link-text">{{department.title}}</p>
    </div>
</div>
